<template>
  <div id="app">
    <a-header></a-header>
    <router-view/>
    <a-footer></a-footer>
  </div>
</template>

<script>
import aHeader from './components/header/header'
import aFooter from './components/footer/footer'

export default {
  name: 'App',
  components: {
    aHeader,
    aFooter
  }
}
</script>

<style>
  body{
    min-width: 320px;
  }
  /*bounce bounceIn bounceInDown 跳跃 flash 闪两下 rubberBand 果冻1 jello 果冻2 swing摆动 tada闹钟 wobble摇摆 */
  /*font-family:"Microsoft YaHei",Helvetica,"Hiragino Sans GB",Arial,sans-serif;*/
  *{ margin:0; padding:0;  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;font-size: 14px;box-sizing: border-box;}
  h1,h2,h3,h4,h5,h6{font-weight:normal; font-size:14px;}
  ul,li{list-style:none; margin:0; padding:0;}
  a{text-decoration:none; }
  i,em{font-style:normal;}
  b,strong{font-weight:normal;}
  input[type=button], input[type=submit], input[type=file], button { cursor: pointer; -webkit-appearance: none; }
  .fl{ float:left;}
  .fr{ float:right;}
  .clearfix:after{content:'.';display:block;height:0;clear:both;visibility:hidden}
  .clearfix{display:inline-block;}
  *html .clearfix{height:1%}
  .clearfix{display:block;}
  th,td{border:1px solid #000; padding:0;}
  table{border-collapse:collapse;}
  input{border: 0;}
  .z-flex{display: flex}

</style>



// WEBPACK FOOTER //
// src/App.vue